export const UPDATE_LICENSE = 'licenseReducer/UPDATE_LICENSE';
export type UPDATE_LICENSE = typeof UPDATE_LICENSE;

export const CLEAR_LICENSE = 'licenseReducer/CLEAR_LICENSE';
export type CLEAR_LICENSE = typeof CLEAR_LICENSE;


// WEBPACK FOOTER //
// ./src/modules/license/constants.ts